export interface ClipboardImage {
  file: File;
  /** Best-effort filename for paste-from-print. Falls back to "screenshot-<ts>.<ext>". */
  filename: string;
}

const MIME_TO_EXT: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/heic': 'heic',
  'image/heif': 'heif',
};

export function extractClipboardImages(items: DataTransferItemList | null | undefined): ClipboardImage[] {
  if (!items) return [];
  const out: ClipboardImage[] = [];
  for (let i = 0; i < items.length; i += 1) {
    const item = items[i];
    if (item.kind !== 'file') continue;
    if (!item.type?.startsWith('image/')) continue;
    const file = item.getAsFile();
    if (!file) continue;
    const ext = MIME_TO_EXT[file.type] ?? 'png';
    const filename = file.name && file.name !== 'image.png'
      ? file.name
      : `screenshot-${Date.now()}-${i}.${ext}`;
    out.push({ file, filename });
  }
  return out;
}

export function withFilename(file: File, filename: string): File {
  return new File([file], filename, { type: file.type, lastModified: file.lastModified });
}
